import QRCode from "react-qr-code";
import {Button, message, Popover} from "antd";
import React, {useCallback, useRef, useState} from 'react';
import { toPng } from 'html-to-image';

export default ({url, filename, children}) => {
  const [loading, setLoading] = useState(false);
  const ref = useRef();

  const onConvert = useCallback(() => {
    if (ref.current === null) {
      return
    }

    toPng(ref.current, { cacheBust: true, })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = filename + '.png';
        link.href = dataUrl;
        link.click();
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      })
  }, [ref]);

  let onClick = () => {
    setLoading(true);
    setTimeout(() => onConvert(), 250);
  }

  let linkCopy = e => {
    e.preventDefault();

    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(url);
      message.success(`Link copied!`);
    }
  }

  let publicLinkContent = <div>
    <div ref={ref} >
      <div className="p-4 bg-white">
        <QRCode value={url} />
      </div>
    </div>
    <div className="py-2 text-center"><a href={url} onClick={linkCopy}>copy text</a></div>
    { filename && <div className="py-2 text-center"><Button type="link" loading={loading} onClick={onClick}>download image</Button></div> }
  </div>

  return <Popover trigger="click" content={publicLinkContent}>
    {children}
  </Popover>
}
